export const SET_APIKEY = 'SET_APIKEY';
export const LOG_OUT = 'LOG_OUT';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_JWT = 'SET_USER_JWT';
export const SET_RESET_INFO = 'SET_RESET_INFO';
export const SET_REGISTER_INFO = 'SET_REGISTER_INFO';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_COOKIES = 'SET_COOKIES';
export const SET_SECRET_QUESTIONS = 'SET_SECRET_QUESTIONS';
